import { type TypingTest } from "./TypingTest";
import { IDisplayScrollManager } from "./types";

export class TypingTestApp {
    private input: HTMLInputElement;
    private wordWrapper: HTMLDivElement;
    private newButton: HTMLButtonElement;
    private debug: HTMLDivElement;
    private test: TypingTest;
    private _scroller: IDisplayScrollManager;
    private wpm: HTMLDivElement;
    private accuracy: HTMLDivElement;

    constructor(typingTest: TypingTest, scroller: IDisplayScrollManager) {
        this.input = this.$('#input') as HTMLInputElement;
        this.wordWrapper = this.$('#word-wrapper') as HTMLDivElement;
        this.newButton = this.$('#new_test') as HTMLButtonElement;
        this.debug = this.$('#debug') as HTMLDivElement;
        this.wpm = this.$('#wpm') as HTMLDivElement;
        this.accuracy = this.$('#accuracy') as HTMLDivElement;
        this.test = typingTest;
        this._scroller = scroller;
        this.init();
    }

    private $(selector: string): Element | null {
        return document.querySelector(selector);
    }

    private init(): void {
        this.input.focus();
        this.addEventListeners();
        this.render();
    }

    private renderDebug(): void {
        this.debug.innerHTML = `
        Test Debug:
            ${this.test.getDebugInfo()}
        Scroll Debug:
            Scroll: ${this._scroller.getDebugInfo()}
        `;
    }

    private render(): void {
        const hasInputError = this.test.inputError();
        this.wordWrapper.innerHTML = this.test.getWords()
            .map((word, index) => {
                const hasError = this.test.errorPositions.includes(index);
                if (hasInputError && index === this.test.getCurrentWordIndex()) {
                    return `<span class="word word__incorrect word__current">${word}</span>`;
                }
                if (index === this.test.getCurrentWordIndex()) {
                    return `<span class="word word__current">${word}</span>`;
                }
                if (hasError) {
                    return `<span class="word word__incorrect">${word}</span>`;
                }
                if (index < this.test.getCurrentWordIndex()) {
                    return `<span class="word word__correct">${word}</span>`;
                }
                return `<span class="word__pending">${word}</span>`;
            })
            .join(' ');

        this._scroller.scrollToCurrentWord(this.test.getCurrentWordIndex());
        if (process.env.NODE_ENV === 'development') {
            this.renderDebug();
        }
        this.wpm.innerHTML = Math.round(this.test.wpm).toString();
        this.accuracy.innerHTML = `${Math.round(this.test.accuracy)}%`;
    }

    private handleInput(): void {
        const value = this.input.value;
        const length = value.length;

        if (value[length - 1] === ' ') {
            this.test.consumeWord();
            this.input.value = '';
            this.render();
            return;
        }

        this.test.checkWord(value);
        if ( this.test.completed) {
            this.input.value = '';
        }
        this.render();
    }

    private addEventListeners(): void {
        this.newButton.addEventListener('click', () => {
            this.test.reset();
            this.render();
            this.input.value = "";
            this.input.focus();
            this._scroller.reset();
        });

        this.input.addEventListener('input', () => this.handleInput());
    }
}
